export default __webpack_public_path__ + "static/media/bsc-news@2x.79602183.png";